import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';

export class Layout extends Component {
  static displayName = Layout.name;

  render() {
    return (
      <div>
        <NavMenu />
        <Container tag="main" style={{maxWidth:1200, minHeight:window.innerHeight-70-32, marginBottom:32}}>
          {this.props.children}
        </Container>
      </div>
    );
  }
}
